module.exports = __webpack_public_path__ + "static/media/sanmarino-flag.dbc5b7da.png";